'use client';

import { Textarea } from '@cloai/uikit';
import { ChangeEvent, FC } from 'react';

interface PromptAreaProps {
  prompt: string;
  placeholder: string;
  changePrompt: (value: string) => void;
  maxLength: number;
  className?: string;
}

export const PromptArea: FC<PromptAreaProps> = ({
  prompt,
  changePrompt,
  maxLength,
  className,
  placeholder,
}) => {
  const isMobile =
    typeof navigator !== 'undefined' &&
    /Android|iPhone|iPad|iPod/.test(navigator.userAgent);

  const getScrollParent = (el: HTMLElement | null): HTMLElement => {
    while (el) {
      const style = window.getComputedStyle(el);
      if (
        (style.overflowY === 'auto' || style.overflowY === 'scroll') &&
        el.scrollHeight > el.clientHeight
      ) {
        return el;
      }
      el = el.parentElement;
    }

    return document.scrollingElement as HTMLElement;
  };

  const onFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if (isMobile) {
      setTimeout(() => {
        const textarea = e.target as HTMLElement;
        const scrollParent = getScrollParent(textarea);
        const parentRect = scrollParent.getBoundingClientRect();
        const targetRect = textarea.getBoundingClientRect();
        const offset = targetRect.top - parentRect.top;
        scrollParent.scrollTo({
          top: scrollParent.scrollTop + offset - 20,
          behavior: 'smooth',
        });
      }, 700);
    }
  };

  const onWrite = (event: ChangeEvent<HTMLTextAreaElement>) => {
    changePrompt(event.target.value);
  };

  return (
    <div>
      <Textarea
        placeholder={placeholder}
        value={prompt}
        onChange={onWrite}
        maxLength={maxLength}
        onFocus={onFocus}
        className={className}
      />
    </div>
  );
};
